"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _clsx = _interopRequireDefault(require("clsx"));

var _spacer = _interopRequireDefault(require("./spacer.css"));

var _useMediaQuery = _interopRequireDefault(require("./utils/useMediaQuery"));

var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));

var _spacer2 = _interopRequireDefault(require("./spacer.defaultProps"));

var dataUtils = new _mmcDataUtilities["default"]();
var shouldUseDataOrDefaultProps = dataUtils.shouldUseDataOrDefaultProps;

var Spacer = function Spacer(props) {
  var data = props.data;

  var _shouldUseDataOrDefau = shouldUseDataOrDefaultProps(data, _spacer2["default"]),
      mobileheight = _shouldUseDataOrDefau.mobileheight,
      tabletheight = _shouldUseDataOrDefau.tabletheight,
      desktopheight = _shouldUseDataOrDefau.desktopheight;

  var isMobile = (0, _useMediaQuery["default"])('(max-width: 767px)');
  var isTablet = (0, _useMediaQuery["default"])('(min-width: 768px) and (max-width: 1023px)');
  var currentHeight = isMobile ? mobileheight : isTablet ? tabletheight : desktopheight;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx["default"])(_spacer["default"].spacer),
    style: {
      height: currentHeight
    }
  });
};

Spacer.defaultProps = {
  data: _spacer2["default"]
};

var mapStateToProps = function mapStateToProps(state, props) {
  return {
    market: props.market || state.Config.market,
    language: props.language || state.Config.language
  };
};

Spacer.resourceType = function () {
  return 'SpacerBlock_1_0_0';
};

var _default = (0, _reactRedux.connect)(mapStateToProps)(Spacer);

exports["default"] = _default;